import { render, staticRenderFns } from "./ticketcount.vue?vue&type=template&id=7298252d"
import script from "./ticketcount.vue?vue&type=script&lang=js"
export * from "./ticketcount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports